import AbstractDataBuilder from "../../core/AbstractDataBuilder";
import CheckoutProgressNormalizersResolver from "./CheckoutProgressNormalizersResolver";
export default class CheckoutProgressDataBuilder extends AbstractDataBuilder {
    static create() {
        if (undefined === this.builderInstance) {
            this.builderInstance = new this(new CheckoutProgressNormalizersResolver());
        }
        return this.builderInstance;
    }
}
